import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SharedReportPage from "./pages/SharedReportPage";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import AdminAuditDetail from "./components/AdminAuditDetail";
import AdminInsights from "./components/AdminInsights";

// Catch-all for any path the router doesn't recognise. Without this, typo'd
// slugs, legacy email links (e.g. the old /report/{audit_id} pattern), or
// pasted-wrong URLs rendered a fully blank page — silent dead end. We keep
// the inline NotFound component so we don't grow the bundle just for a 404.
function NotFoundPage() {
  return (
    <div
      data-testid="not-found-page"
      style={{
        minHeight:'100dvh', background:'#F0F1F7',
        display:'flex', alignItems:'center', justifyContent:'center',
        padding:'40px 20px',
      }}
    >
      <div style={{ textAlign:'center', maxWidth:420 }}>
        <div style={{ fontFamily:"'Outfit',sans-serif", fontSize:13, fontWeight:700, letterSpacing:'0.16em', textTransform:'uppercase', color:'rgba(10,10,26,0.45)', marginBottom:14 }}>
          404 — page not found
        </div>
        <h1 style={{ fontFamily:"'Outfit',sans-serif", fontSize:28, fontWeight:800, color:'#0A0F2E', marginBottom:10, lineHeight:1.2 }}>
          We couldn't find that page
        </h1>
        <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:14, color:'rgba(10,10,26,0.65)', lineHeight:1.6, marginBottom:24 }}>
          The link may have expired, been mistyped, or the audit may no longer be available.
          Head back to the home page to run a new audit.
        </p>
        <a
          href="/"
          style={{
            display:'inline-block', padding:'12px 22px', borderRadius:10,
            background:'#2D4DE0', color:'#fff', fontFamily:"'Outfit',sans-serif",
            fontWeight:700, fontSize:14, textDecoration:'none',
            boxShadow:'0 8px 24px rgba(45,77,224,0.28)',
          }}
        >
          Back to home →
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/share/:slug" element={<SharedReportPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/audits/:id" element={<AdminAuditDetail />} />
        <Route path="/admin/insights" element={<AdminInsights />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
